module.exports = __webpack_public_path__ + "static/media/antigua-beaches-57.532e6456.jpg";